export const APP_ACTIONS = {
  SET_CUSTOMIZER_VISIBILITY: 'set-customizer-visibility',
  SET_CONTAINER_STYLE: 'set-container-style',
  SET_APP: 'set-app',
};
